import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

// Bilde i fullskjerm. Ligger over bunnarkene (SheetModal har z-index 1500), og Escape lukker bare
// bildet, ikke arket under.
export default function ImageViewer({ url, label, signature, onClose }) {
  useEffect(() => {
    const handler = (e) => {
      if (e.key !== 'Escape') return;
      e.stopImmediatePropagation();
      onClose();
    };
    document.addEventListener('keydown', handler, true);
    return () => document.removeEventListener('keydown', handler, true);
  }, [onClose]);

  return ReactDOM.createPortal(
    <div style={styles.overlay} onClick={onClose} role="dialog" aria-modal="true" aria-label={label}>
      <button type="button" style={styles.closeBtn} onClick={onClose} aria-label="Lukk" autoFocus>✕</button>
      <img
        src={url}
        alt={label}
        onClick={e => e.stopPropagation()}
        // Signaturen er mørk strek på gjennomsiktig bakgrunn — trenger hvit bunn
        style={{ ...styles.fullImg, ...(signature ? { background: '#ffffff', padding: 16 } : {}) }}
      />
      <div style={styles.label}>{label}</div>
    </div>,
    document.body
  );
}

const styles = {
  overlay:  { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.88)', zIndex: 2000, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: 16 },
  fullImg:  { maxWidth: '100%', maxHeight: '82vh', objectFit: 'contain', borderRadius: 6, boxSizing: 'border-box' },
  label:    { color: '#fff', fontSize: 13, marginTop: 10, opacity: 0.85 },
  closeBtn: { position: 'absolute', top: 12, right: 12, width: 44, height: 44, borderRadius: '50%', border: 'none', background: 'rgba(255,255,255,0.15)', color: '#fff', fontSize: 18, cursor: 'pointer' },
};
